'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userChildren = require('./user-children.html');

var _userChildren2 = _interopRequireDefault(_userChildren);

var _userChildren3 = require('./user-children.controller');

var _userChildren4 = _interopRequireDefault(_userChildren3);

require('./user-children.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userChildrenComponent = {
  restrict: 'E',
  bindings: {
    children: '<'
  },
  template: _userChildren2.default,
  controller: _userChildren4.default,
  controllerAs: 'vm'
};

exports.default = userChildrenComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-children/user-children.component.js
 **/